import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const PayrollSetupApi = createApi({
  reducerPath: 'PayrollSetupApi',
  baseQuery,
  tagTypes: ['setup'],
  endpoints: builder => ({
    getDeduction: builder.query<
      any,
      {
        payGrade?: string;
        employeeType?: string;
        search?: string;
        employee?: string;
      } | void
    >({
      query: params => {
        const queryParams = new URLSearchParams();
        if (params?.payGrade) queryParams.append('payGrade', params.payGrade);
        if (params?.employeeType)
          queryParams.append('employeeType', params.employeeType);
        if (params?.search) queryParams.append('q', params.search);
        if (params?.employee) queryParams.append('employee', params.employee);
        return `/payroll/deductions?${queryParams.toString()}`;
      },
      providesTags: ['setup'],
    }),
    createDeduction: builder.mutation<any, any>({
      query: newDeduction => ({
        url: '/payroll/deductions',
        method: 'POST',
        body: newDeduction,
      }),
      invalidatesTags: ['setup'],
    }),
    updateDeduction: builder.mutation<any, { id: string; updates: any }>({
      query: ({ id, updates }) => ({
        url: `/payroll/deductions/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['setup'],
    }),
    deleteDeduction: builder.mutation<void, number>({
      query: id => ({
        url: `/payroll/deductions/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['setup'],
    }),
  }),
});

export const {
  useGetDeductionQuery,
  useCreateDeductionMutation,
  useUpdateDeductionMutation,
  useDeleteDeductionMutation,
} = PayrollSetupApi;
